import api from '../config/api';

export const userLogin = credentials =>
  api.post('auth/sign_in', { username: credentials.username, password: credentials.password });
